import { Link } from "react-router-dom";
import { specials } from "@/mocks/specials";
import { allWorks } from "@/utils/catalog";

const accentBar: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

const accentChip: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function SpecialShowcase() {
  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
      {specials.slice(0, 6).map((sp, i) => {
        const count = sp.groups.reduce((sum, g) => sum + g.workIds.length, 0);
        return (
          <Link
            key={sp.id}
            to={`/special/${sp.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 animate-fade-up"
            style={{ animationDelay: `${i * 70}ms` }}
          >
            <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
              <img
                src={sp.cover}
                alt={`${sp.title}专题封面`}
                title={`${sp.title} - ${sp.subtitle}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 to-transparent"></div>
              <span className={`absolute left-3 top-3 h-1.5 w-10 rounded-full ${accentBar[sp.accent]}`}></span>
              <div className="absolute inset-x-3 bottom-2.5">
                <h3 className="font-heading text-lg font-bold text-background-50">{sp.title}</h3>
                <p className="text-xs text-primary-100">{sp.subtitle}</p>
              </div>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <p className="flex-1 text-xs leading-relaxed text-foreground-600 line-clamp-3">
                {sp.intro}
              </p>
              <div className="mt-3 flex items-center justify-between">
                <span className={`rounded-full px-2 py-0.5 text-[11px] ${accentChip[sp.accent]}`}>
                  收录 {count} 部作品
                </span>
                <span className="flex items-center gap-1 text-xs font-medium text-primary-700">
                  进入专题
                  <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-1">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}